import { Injectable } from '@angular/core';
import { TableDatasource } from '@core/api/table.datasource';
import { BatchJob } from './batch-job.model';
import { BatchJobSearchParams } from './batch-job-search-params.model';

@Injectable({
  providedIn: 'root',
})
export class BatchJobDatasource extends TableDatasource<
  BatchJob,
  BatchJobSearchParams
> {
  endpoint = '/api/admin/batchjobs';
  defaultSortField = 'start';
  override defaultDescending = true;
}
